import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success-circle",
  "use": "icon-success-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" role=\"presentation\" id=\"icon-success-circle\"><g fill-rule=\"evenodd\"><circle fill=\"#36b37e\" cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z\" fill=\"#ffffff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol